// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { toLower } from 'lodash/fp';

const REPORT = toLower(localizer.getText('COMMON_LABEL_REPORT'));
const DASHBOARD = toLower(localizer.getText('COMMON_LABEL_DASHBOARD'));
const EDITABLE = toLower(localizer.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_EDITABLE'));
const ACCESSIBLE = toLower(localizer.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_ACCESSIBLE'));
const DATA_SOURCE_CONCAT_TREE_MAP = [
  {
    prop: 'childNodes',
    children: [
      {
        prop: 'childNodes',
        showTotal: true,
        children: [
          {
            prop: 'childNodes',
            children: [
              {
                prop: 'childNodes'
              }
            ]
          }
        ]
      }
    ]
  }
];

export default {
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  MIDDLE_MIN_WIDTH: 0,
  MIDDLE_MAX_WIDTH: 250,
  MESSAGE: {
    get DELETE() {
      return localizer.getText('ROLE_SETUP_CONSTANT_MESSAGE_DELETE');
    },
    get DEACTIVE() {
      return localizer.getText('ROLE_SETUP_CONSTANT_MESSAGE_DEACTIVE');
    },
    get PERMISSION_ERROR() {
      return localizer.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR');
    }
  },
  PERMISSION_ERROR: {
    validateReportUneditableCategoryKey: {
      type: REPORT,
      permission: EDITABLE
    },
    validateReportInaccessibleCategoryKey: {
      type: REPORT,
      permission: ACCESSIBLE
    },
    validateDashboardUneditableCategoryKey: {
      type: DASHBOARD,
      permission: EDITABLE
    },
    validateDashboardInaccessibleCategoryKey: {
      type: DASHBOARD,
      permission: ACCESSIBLE
    }
  },
  ROLE_STATE: {
    get ACTIVATE() {
      return localizer.getText('COMMON_LABEL_ACTIVATE');
    },
    get DEACTIVATE() {
      return localizer.getText('COMMON_LABEL_DEACTIVATE');
    }
  },
  CONSTRAINTS: {
    ROLE_NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('ROLE_SETUP_CONSTANT_CONSTRAINTS_REQUIRE_VALUE');
        }
      }
    }
  },
  ROLE_SETUP: {
    get USERS() {
      return localizer.getText('ROLE_SETUP_CONSTANT_ROLE_SETUP_USERS');
    }
  },
  DEFAULT_ITEMS_LAZY_LOADING: 100,
  DATA_SOURCE_CONCAT_TREE_MAP,
  DATA_SOURCE_TREE_MAP: [
    {
      prop: 'childNodes',
      children: DATA_SOURCE_CONCAT_TREE_MAP
    }
  ],
  ROLE_TYPES: {
    Administrator: 'Administrator',
    AdvReportCreator: 'AdvReportCreator',
    BasicReportCreator: 'BasicReportCreator',
    ReportViewer: 'ReportViewer',
    Custom: 'Custom'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.RoleSetupConstants.js